import { type FC, Fragment } from "react";
import { useTranslation } from "react-i18next";

export interface AddressData {
  id: string;
  companyName: string;
  lines: string[];
  country: {
    name: string;
    isocode: string;
  };
  town: string;
  postalCode: string;
  default: boolean;
  editable: boolean;
  temporary: boolean;
  state: string;
  parentUnit?: string;
}

export interface UnloadingPointData {
  id: string;
  name: string;
  selected: boolean;
}

interface AddressProps {
  data?: AddressData;
  as?: keyof JSX.IntrinsicElements;
}

const Address: FC<AddressProps> = (props) => {
  if (!props.data) {
    return null;
  }

  const { lines, country, companyName } = props.data;
  const Tag = props.as!;
  const { t } = useTranslation();
  return (
    <Tag>
      {companyName && (
        <span className={"f-pre-line"}>
          {companyName}
          <br />
        </span>
      )}
      {lines
        .filter((line) => line)
        .map((line, index) => (
          <Fragment key={index}>
            {line}
            <br />
          </Fragment>
        ))}
      {t(country.name)}
    </Tag>
  );
};

Address.defaultProps = {
  as: "p",
};

export default Address;
